export const AI_QUOTES = [
    "Your time is limited, don't waste it living someone else's life.",
    "Stay hungry, stay foolish.",
    "The best way to predict the future is to create it.",
    "Innovation distinguishes between a leader and a follower.",
    "Design is not just what it looks like and feels like. Design is how it works.",
    "Be the change that you wish to see in the world.",
    "Happiness depends upon ourselves.",
    "The journey of a thousand miles begins with one step.",
    "Believe you can and you're halfway there.",
    "Action is the foundational key to all success.",
    "The only limit to our realization of tomorrow will be our doubts of today.",
    "Do what you can, with what you have, where you are.",
    "It always seems impossible until it's done.",
    "Success is not final, failure is not fatal: it is the courage to continue that counts.",
    "Don't count the days, make the days count.",
    "Everything you've ever wanted is on the other side of fear.",
    "Start where you are. Use what you have. Do what you can.",
    "The best revenge is massive success.",
    "Your work is going to fill a large part of your life, and the only way to be truly satisfied is to do what you believe is great work.",
    "Quality is not an act, it is a habit.",
    "Life is what happens when you're busy making other plans.",
    "Get busy living or get busy dying.",
    "You only live once, but if you do it right, once is enough.",
    "In the middle of every difficulty lies opportunity.",
    "The mind is everything. What you think you become.",
    "The only way to do great work is to love what you do.",
    "The function of leadership is to produce more leaders, not more followers.",
    "If you want to live a happy life, tie it to a goal, not to people or things.",
    "Never let the fear of striking out keep you from playing the game.",
    "Money and success don't change people; they merely amplify what is already there.",
    "Not how long, but how well you have lived is the main thing.",
    "If life were predictable it would cease to be life, and be without flavor.",
    "The big lesson in life, baby, is never be scared of anyone or anything.",
    "Curiosity about life in all of its aspects, I think, is still the secret of great creative people.",
    "Life is not a problem to be solved, but a reality to be experienced.",
    "The unexamined life is not worth living.",
    "Turn your wounds into wisdom.",
    "The way I see it, if you want the rainbow, you gotta put up with the rain.",
    "Do all the good you can, for all the people you can, in all the ways you can, as long as you can.",
    "Don't settle for what life gives you; make life better and build something.",
    "Everything negative – pressure, challenges – is all an opportunity for me to rise.",
    "I like criticism. It makes you strong.",
    "You never really learn much from hearing yourself speak.",
    "Life imposes things on you that you can’t control, but you still have the choice of how you’re going to live through this.",
    "Life is never easy. There is work to be done and obligations to be met – obligations to truth, to justice, and to liberty.",
    "Live for each day as if it were your last.",
    "Life is very short and anxious for those who forget the past, neglect the present, and fear the future.",
    "The greatest glory in living lies not in never falling, but in rising every time we fall.",
    "Way to get started is to quit talking and begin doing.",
    "Your mindset is the most important tool you have.",
    "Don't wait for opportunity. Create it.",
    "The harder you work for something, the greater you'll feel when you achieve it.",
    "Dream bigger. Do bigger.",
    "Don't stop when you're tired. Stop when you're done.",
    "Wake up with determination. Go to bed with satisfaction.",
    "Do something today that your future self will thank you for.",
    "Little things make big days.",
    "It’s going to be hard, but hard does not mean impossible.",
    "Don’t wait for inspiration. It has to find you working.",
    "Great things never come from comfort zones.",
    "Dream it. Wish it. Do it.",
    "Success doesn’t just find you. You have to go out and get it.",
    "The key to success is to focus on goals, not obstacles.",
    "Dream it. Believe it. Build it.",
    "Success is what happens after you have survived all of your mistakes.",
    "Build your own dreams, or someone else will hire you to build theirs.",
    "The only person you are destined to become is the person you decide to be.",
    "Success is walking from failure to failure with no loss of enthusiasm.",
    "What you do speaks so loudly that I cannot hear what you say.",
    "I haven’t failed. I’ve just found 10,000 ways that won’t work.",
    "If you are not embarrassed by the first version of your product, you’ve launched too late.",
    "It’s not about ideas. It’s about making ideas happen.",
    "The value of an idea lies in the using of it.",
    "Ideas are easy. Implementation is hard.",
    "Don’t worry about people stealing your design work. Worry about the day they stop.",
    "Simplicity is the ultimate sophistication.",
    "Design is a solution to a problem. Art is a question to a problem.",
    "Make it simple, but significant.",
    "The details are not the details. They make the design.",
    "Good design is obvious. Great design is transparent.",
    "Every great design begins with an even better story.",
    "Design adds value faster than it adds costs.",
    "An essential aspect of creativity is not being afraid to fail.",
    "You can't use up creativity. The more you use, the more you have.",
    "Creativity is intelligence having fun.",
    "Don't be afraid to give up the good to go for the great.",
    "I find that the harder I work, the more luck I seem to have.",
    "Opportunities don't happen. You create them.",
    "I never dreamed about success, I worked for it.",
    "Try not to become a man of success. Rather become a man of value.",
    "The successful warrior is the average man, with laser-like focus.",
    "Success usually comes to those who are too busy to be looking for it.",
    "If you really look closely, most overnight successes took a long time.",
    "The secret of success is to do the common thing uncommonly well.",
    "I owe my success to having listened respectfully to the very best advice, and then going away and doing the exact opposite.",
    "I don't know the word 'quit.' Either I never did, or I have abolished it.",
    "The only place where success comes before work is in the dictionary.",
    "Success is like your own shadow. If you try to catch it, you will never succeed. If you walk towards your goal, it will follow you.",
    "The road to success and the road to failure are almost exactly the same.",
    "I attribute my success to this: I never gave or took any excuse.",
    "Success is falling nine times and getting up ten.",
    "I’m a greater believer in luck, and I find the harder I work the more I have of it.",
    "To be successful, you must accept all challenges that come your way. You can't just accept the ones you like.",
    "Logic will get you from A to B. Imagination will take you everywhere.",
    "Everything is a resource. You just have to figure out how to use it.",
    "Your work is a reflection of your state of mind.",
    "Discipline is choosing between what you want now and what you want most.",
    "Focused, hard work is the real key to success.",
    "Consistency is more important than intensity.",
    "The best way to get things done is to just start.",
    "Done is better than perfect.",
    "Shipping is a feature.",
    "Focus on the process, not the outcome.",
    "Your competition is the version of yourself from yesterday.",
    "Measure twice, cut once.",
    "The most powerful tool you have is 'No'.",
    "Don't build features, solve problems.",
    "Fall in love with the problem, not the solution.",
    "Small wins lead to big victories.",
    "Complexity is the enemy of execution.",
    "Velocity is more important than speed.",
    "Trust the process.",
    "Stay curious.",
    "Learn by doing.",
    "Teaching is the best way to learn.",
    "Every expert was once a beginner.",
    "Mastery takes time.",
    "Be so good they can't ignore you.",
    "Quality over quantity.",
    "Subtract until it's perfect.",
    "Less is more.",
    "Detail matters.",
    "User experience is everything.",
    "Feedback is a gift.",
    "Pivot when necessary.",
    "Persistence pays off.",
    "Hard work beats talent when talent doesn't work hard.",
    "Luck is what happens when preparation meets opportunity.",
    "The only way to fail is to quit.",
    "One more try.",
    "Keep pushing.",
    "Break the rules.",
    "Think different.",
    "Challenge the status quo.",
    "Innovate or die.",
    "The future belongs to the creators.",
    "Make something people want.",
    "Solve your own problems.",
    "Default to action.",
    "Extreme ownership.",
    "Radical candor.",
    "Empathy is a superpower.",
    "Listen more than you speak.",
    "Ask better questions.",
    "Be a lifelong learner.",
    "Read, lead, succeed.",
    "Writing is thinking.",
    "Clarify your thoughts.",
    "Find your flow.",
    "Optimize for happiness.",
    "Balance is a myth, prioritize.",
    "Health is wealth.",
    "Rest is productive.",
    "Burnout is real, take care.",
    "Celebrate the wins.",
    "Gratitude changes everything.",
    "Kindness is free.",
    "Help others win.",
    "Build a network of legends.",
    "Your network is your net worth.",
    "Surround yourself with the best.",
    "Be a giver, not a taker.",
    "Leave it better than you found it.",
    "The best is yet to come.",
    "Trust yourself.",
    "You are capable of more than you think.",
    "Take the leap.",
    "Fortune favors the bold.",
    "Everything is figureoutable.",
    "One day or Day One. You decide.",
    "Focus on what you can control.",
    "Let go of what you can't.",
    "The obstacle is the way.",
    "Ego is the enemy.",
    "Stillness is the key.",
    "Memento mori.",
    "Amor fati.",
    "Live in the present.",
    "Be here now.",
    "Slow down to speed up.",
    "Think long term.",
    "Compounding is magic.",
    "Patience is a competitive advantage.",
    "Build for the long haul.",
    "Legacy over currency.",
    "Impact over income.",
    "Create more value than you capture.",
    "The game is won in the mind.",
    "Mental models are leverage.",
    "First principles thinking.",
    "Systems over goals.",
    "Automation is freedom.",
    "Outsource the mundane.",
    "Focus on your unique ability.",
    "Scalability is the goal.",
    "Design for scale.",
    "Mobile first.",
    "Cloud native.",
    "Open source everything.",
    "Privacy is a human right.",
    "Security is not an afterthought.",
    "Speed is a feature.",
    "Performance is UX.",
    "Clean code is maintainable code.",
    "Documentation is love.",
    "Tests are confidence.",
    "Refactor early, refactor often.",
    "Keep it DRY.",
    "KISS - Keep It Simple, Stupid.",
    "YAGNI - You Ain't Gonna Need It.",
    "Agile is a mindset.",
    "DevOps is a culture.",
    "Cloud is just someone else's computer.",
    "API first.",
    "Serverless is the future.",
    "Edge computing is near.",
    "AI is a tool, use it wisely.",
    "Data is the new oil.",
    "Information is power.",
    "Knowledge is wealth.",
    "Wisdom is freedom.",
    "Peace is the ultimate goal."
];
